import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';
import { wrapFetch } from '#/fetch-wrapper';


/*
* AMENITY TAGS
*/


const fetchAmenityTags = () => wrapFetch(() => api.get('/amenity-tags'));
const createAmenityTags = payload => wrapFetch(() => api.post('/amenity-tags', payload));
const deleteAmenityTags = tag => wrapFetch(() => api.delete(`/amenity-tags/${tag}`));

const updateAmenityTags = payload => wrapFetch(() => api.put('/amenity-tags', payload));


export const useAmenityTags = (queryOptions = {}) => useQuery(['amenity-tags'], () => fetchAmenityTags(), queryOptions);
export const useDeleteAmenityTags = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(({ tag }) => deleteAmenityTags(tag), {
        onSuccess: () => {
            queryClient.invalidateQueries('amenity-tags');
        },
        ...queryOptions
    });
};

export const useCreateAmenityTags = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => createAmenityTags(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('amenity-tags');
        },
        ...queryOptions
    });
};

export const useUpdateAmenityTags = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(({
        payload
    }) => updateAmenityTags(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('amenity-tags');
            queryClient.invalidateQueries('amenity-types');
        },
        ...queryOptions
    });
};
